"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightPassengersCell = void 0;
const react_1 = __importDefault(require("react"));
const FlightPassengers_1 = require("../FlightPassengers");
const FlightPassengersCell = (props) => {
    const { reservation, flight } = props;
    if (flight === undefined)
        return null;
    const { passengers } = reservation;
    const isDeparted = flight.status === 'departed' || flight.status === 'closed';
    return (react_1.default.createElement(FlightPassengers_1.ReservationListFlightPassengers, { flight: flight, passengers: passengers, modificators: isDeparted ? 'departed' : undefined }));
};
exports.FlightPassengersCell = FlightPassengersCell;
//# sourceMappingURL=FlightPassengersCell.js.map